export function calculateTotalPercent (percents, totalPercent) {
  const results = []
  const sumPercents = percents.reduce((sum, percent) => sum + percent, 0)

  if (sumPercents === 0) {
    throw new Error('Total percents cannot be zero')
  }

  percents.forEach((percent, index) => {
    const proportionalShare = (percent / sumPercents) * totalPercent
    const integerPart = Math.floor(proportionalShare)
    const remainder = proportionalShare - integerPart

    results.push({
      index,
      percent,
      integerPart,
      remainder,
      allocation: integerPart
    })
  })

  // Sort by remainders in descending order
  results.sort((a, b) => b.remainder - a.remainder)

  // Distribute the remaining quantity to items with the largest remainders
  const remainingQuantity = totalPercent - results.reduce((sum, result) => sum + result.allocation, 0)
  for (let i = 0; i < remainingQuantity; i++) {
    results[i].allocation++
  }

  // Sort results back to the original order
  results.sort((a, b) => a.index - b.index)

  return results.map((result) => result.allocation)
}



// WEBPACK FOOTER //
// ./src/helpers/percentagesTo100.js